import { Helmet } from "react-helmet-async";

export default function PersonalLoanPage() {
  
    return (
      <div className="w-full min-h-screen bg-gray-100 p-4">
         <Helmet>
                <title>Kota HOLDINGS</title>
                <meta name="description" content="A Vision of My 30-Year World" />
              </Helmet>
        <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-[#FF6F00] text-white p-6">
            <h2 className="text-2xl font-bold">We provide the best value Personal Loan</h2>
            <p className="mt-2">Get instant approval for personal loans with minimal documentation and quick disbursal.</p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
              <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
              <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
              <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
            </div>
            <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
            <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Apply Now</button>
          </div>
        </div>
        <div className=" mx-auto overflow-hidden mt-6">
          <div className="p-6">
            <h3 className="text-xl font-bold">Personal Loan Eligibility</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Age should be between 21 to 60 years.</li>
              <li>Minimum net monthly income: Rs. 15,000 for salaried individuals.</li>
              <li>Self-employed individuals must have yearly transactions of at least 20 lakhs.</li>
              <li>Credit score must be above 650.</li>
              <li>Stable employment and a good credit history.</li>
              <li>Must be a resident citizen of India.</li>
            </ul>
          </div>
          <div className="p-6 bg-gray-50">
            <h3 className="text-xl font-bold">Documents Required for Personal Loan</h3>
            <ul className="list-disc ml-6 mt-2">
              <li>Identity Proof: Passport, Voter’s ID, Driving License, PAN Card, Aadhaar Card.</li>
              <li>Address Proof: Passport, Voter’s ID, Electricity Bill, Ration Card, etc.</li>
              <li>Age Proof: Passport, PAN Card, Aadhaar Card.</li>
              <li>Income Proof: 1-year bank statement, 3 months salary slips.</li>
              <li>Employment Proof: Employment certificate, office address proof.</li>
              <li>GST/VAT Registration for self-employed individuals.</li>
              <li>Business Proof: MOA, AOA, partnership deed, etc.</li>
              <li>Income tax returns: Last 2-3 years for income verification.</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
  